import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkflowConfigurator } from './ViewModules/shared-components/workflow-configurator/workflow-configurator.component';

const routes: Routes = [
  { path: 'claims', loadChildren: () => import('./ViewModules/Claims/claims.module').then(m => m.ClaimsModule) },
  { path: 'nbu', loadChildren: () => import('./ViewModules/Newbusiness/newbusiness.module').then(m => m.NewBusinessModule) },
  { path: 'policyServicing', loadChildren: () => import('./ViewModules/PolicyServicing/policyServicing.module').then(m => m.PolicyServicingModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class GlobalAppRoutingModule { }
